import React from 'react';
import {connect} from 'react-redux';
import {checkModuleGroup} from '~/utils/permissions';

const mapStateToProps = (state) => ({
    modules: state.context.modules
});

export const PermissionModuleGroup = connect(mapStateToProps)(({
                                                        modules,
                                                        type = '',
                                                        children,
                                                        fallback = null,
                                                    }) => {
    return checkModuleGroup(modules, type) ? (
        children
    ) : fallback
});
